<div *ngIf="this.popupAtecoIsOpen" [class.bg-modal--open]="this.popupAtecoIsOpen" class="bg-modal bg-modal--ateco">
  <div id="bg" #bg class="modal-contents">
    <div class="modal-contents__top py-2 px-4">
      <div class="fw-500"></div>
      <div (click)="handleClosePopupAtecoEvt()" class="close">+</div>
    </div>
    <div class="modal-contents__body pt-2 pb-4 px-4">
      <div class="modal-contents__body__firstRow d-md-flex  align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <!-- <div class="modal-contents__body__roundedImage me-2"></div> -->
          <div *ngIf="this.objType === 'agency' || this.objType === 'ateco_company'"
            class="modal-contents__body__name text-uppercase mb-0">{{
            this.atecoCompanyObj.ragioneSociale | titlecase
            }}
          </div>
          <div *ngIf="this.objType === 'agent' || this.objType === 'ateco_company_agent'"
            class="modal-contents__body__name text-uppercase mb-0">
            {{
            this.esponente?.name ? this.esponente.name : this.agentFullName ? this.agentFullName :
            this.atecoCompanyObj?.esponenti[0]?.name
            }}
          </div>
        </div>
        <div class="modal-contents__body__badge d-flex align-items-center mt-2 mt-lg-0">
          <div class=" cardSearchAteco__topSection__badge text-uppercase">
            {{
            (this.objType === 'agent' || this.objType === 'ateco_company_agent') ? "Agente immobiliare verificato"
            :
            "Agenzia immobiliare verificata"
            }}
          </div>
          <i [tooltip]="(objType === 'agent' || this.objType === 'ateco_company_agent') ? 'Agente presente in Camera di Commercio con Codice Ateco 68.31 Attività di Mediazione Immobiliare (ultima verifica: Luglio 2024)' : 'Agenzia presente in Camera di Commercio con Codice Ateco 68.31 Attività di Mediazione Immobiliare (ultima verifica: Luglio 2024)'"
            class="ms-1 icon-question-circle cursor-pointer"></i>
        </div>
      </div>

      <p class="mb-0 disclaimer">L' {{this.objType === 'agency' || this.objType === 'ateco_company' ? 'agenzia' :
        'agente'}}
        risulta
        regolarmente iscritta alla
        Camera di
        Commercio
        con il codice di attività mediazione immobiliare.</p>

      <div class="d-md-flex align-items-start justify-content-between mt-3">
        <div>
          <p *ngIf="esponenteName" class="mb-0"><span class="text-primary">Esponente:</span>
            {{ this.esponenteName }}</p>
          <p *ngIf="objType === 'agent' || this.objType === 'ateco_company_agent'" class="mb-0"><span
              class="text-primary">Agenzia:
            </span>{{
            this.atecoCompanyObj?.ragioneSociale |
            titlecase
            }}</p>

          <p *ngIf="this.atecoCompanyObj?.indirizzoCompleto" class="mb-0"><span
              class="text-primary">Città:</span>{{this.main.getCityRegex(this.atecoCompanyObj.indirizzoCompleto, true)}}
          </p>
          <p *ngIf="this.atecoCompanyObj?.partitaIVA" class="mb-0"><span class="text-primary">P. IVA:
            </span>{{ this.atecoCompanyObj.partitaIVA }}</p>
          <p *ngIf="this.atecoCompanyObj?.partitaIVA == null && this.atecoCompanyObj?.codiceFiscale" class="mb-0">
            <span class="text-primary">Codice fiscale:</span> {{ this.atecoCompanyObj?.codiceFiscale }}
          </p>

          <p *ngIf="this.atecoCompanyObj.naturaGiuridica" class="mb-0">
            <span class="text-primary">Natura giuridica: </span>{{ this.atecoCompanyObj.naturaGiuridica }}
          </p>

          <p *ngIf="this.atecoCompanyObj.sulMercatoDa" class="mb-0"><span class="text-primary">Inizio attività:</span>
            {{
            this.atecoCompanyObj.sulMercatoDa |
            date:'dd/MM/yyyy'
            }}</p>
          <ng-container *ngIf="objType == 'agent' || this.objType === 'ateco_company_agent'" class="mb-0">
            <a (click)="this.findSlugFromFullName(this.agentFullName)" style="font-size: 14px;"
              class="text-primary cursor-pointer fw-500">Più
              informazioni</a>
          </ng-container>
          <ng-container *ngIf="objType == 'agency' || this.objType === 'ateco_company'" class="mb-0">
            <a style="font-size: 14px;" class="text-primary fw-500"
              href="/dettaglio-agenzia-ateco/{{this.atecoCompanyObj?.slug}}">Più informazioni</a>
          </ng-container>

        </div>
        <div [tooltip]="'Codice Ateco n°68.31 verificato (ultima verifica: Luglio 2024)'"
          class="mt-2 mt-md-0 modal-contents__body__logoAteco cursor-pointer d-flex align-items-center">
          <div class="modal-contents__body__logoAteco__imgCont position-relative">
            <img [ngSrc]="'assets/img/logo_ateco.png'" fill="center" alt="logo ateco">
          </div>
          <p style="color: white;" class="ms-1 mb-0">68.31</p>
        </div>
      </div>

      <ng-container *ngIf="this.atecoCompanyObj.location?.coordinates && this.hideMapInPopupAteco == false;">
        <h6 class="mb-1 mt-2">Mappa</h6>
        <app-map-page-detail [mapIsInThePopup]="true" [long]="this.atecoCompanyObj.location?.coordinates[1]"
          [lat]="this.atecoCompanyObj.location?.coordinates[0]">
        </app-map-page-detail>
      </ng-container>

      <div class="modal-contents__body__poweredby d-md-flex align-items-center justify-content-between mt-3">
        <p class="mb-0">Sei tu? Registrati a <a class="text-primary fw-500" href="{{this.dashboardLink}}"
            target="_blank">Cercacasa</a></p>
        <div class="d-flex align-items-center">
          <p class="mb-0 me-1">Powered by</p>
          <a href="https://www.whuis.com/" target="_blank">
            <div class="ms-md-1 logo d-flex align-items-center">
              <img width="65" height="21" [ngSrc]="'assets/img/whuisLogo.png'" alt="logo Whuis">
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>